var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["live-calendar", { "no-events": _vm.upcomingEvents.length === 0 }]
    },
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("Sports.LiveCalendar")))]),
      _vm._v(" "),
      !this.idfosporttype && Object.keys(_vm.avalableSports).length > 0
        ? _c(
            "div",
            { staticClass: "sports" },
            _vm._l(_vm.avalableSports, function(sporttypename, sporttypeid) {
              return _c(
                "span",
                {
                  class: [
                    "sporttab",
                    { active: _vm.selectedSportTypeComputed === sporttypeid }
                  ],
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.selectSportType(sporttypeid)
                    }
                  }
                },
                [
                  _c("span", {
                    class: ["sport-icon", "Spicon-" + sporttypeid]
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(sporttypename) +
                      " (" +
                      _vm._s(
                        _vm.upcomingEvents.filter(function(ev) {
                          return ev.IDFOSportType === sporttypeid
                        }).length
                      ) +
                      ")\n    "
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.upcomingEvents.length > 0
        ? _c(
            "div",
            { staticClass: "days" },
            _vm._l(_vm.weekDays, function(day) {
              return _c(
                "span",
                {
                  class: [
                    "daytab",
                    { active: _vm.dayNames[_vm.selectedDayIndex] === day }
                  ],
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.selectDay(day)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(day) + "\n      ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "events" },
        [
          _vm._l(_vm.upcomingEventsPerSportAndDay, function(event) {
            return _vm.upcomingEventsPerSportAndDay &&
              _vm.upcomingEventsPerSportAndDay.length > 0
              ? _c(
                  "div",
                  { staticClass: "event" },
                  [
                    _c("live-event-info", {
                      attrs: {
                        event: event,
                        isawaitingstart: event.isawaitingstart
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.upcomingEventsPerSportAndDay.length === 0
            ? _c("div", [_vm._v(_vm._s(_vm.$t("Sports.NoAvailableEvents")))])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d55e5e2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d55e5e2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/live/liveCalendar.vue
// module id = null
// module chunks = 